import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateInsurance } from '@flecto/api/saas'
import { type CoreInsurance } from '@flecto/types'

type MutationPayload = {
  insurance: Pick<CoreInsurance, 'notes' | 'internal_id'>
}

export function useMutationUpdateInsurance() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationUpdateInsurance'],
    mutationFn: async ({ insurance }: MutationPayload) => {
      await updateInsurance(insurance)

      queryClient.invalidateQueries([
        'QueryGetInsuranceById',
        String(insurance.internal_id),
      ])
    },
  })
}
